import api from '@services/api';
import {
  NewSpecificAllocationBody,
  SpecificAllocation,
  SpecificAllocationByProject,
} from '../models/specificAllocation';

/**
 * <p>
 * API endpoints that cover all Specific allocation related CRUD calls
 */

export const SpecificAllocationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    findAllSpecificAllocationsGrouped: builder.query<SpecificAllocation[], void>({
      query: () => ({
        url: encodeURI(`/indirect/rule-specific-allocation/findAllGrouped`),
      }),
      providesTags: ['SpecificAllocation'],
    }),
    findAllSpecificAllocationsByProject: builder.query<SpecificAllocationByProject[], string>({
      query: (input: string) => ({
        url: encodeURI(`/indirect/rule-specific-allocation/findAllByProject?projectCode=${input}`),
      }),
      providesTags: ['SpecificAllocationByProject'],
    }),
    createSpecificAllocation: builder.mutation<void, NewSpecificAllocationBody>({
      query: (input: NewSpecificAllocationBody) => ({
        url: encodeURI(`/indirect/rule-specific-allocation/create`),
        body: input,
        method: 'POST',
      }),
      invalidatesTags: ['SpecificAllocation'],
    }),
    deleteSpecificAllocation: builder.mutation<void, string>({
      query: (input: string) => ({
        url: encodeURI(`/indirect/rule-specific-allocation/delete?projectCode=${input}`),
        method: 'DELETE',
      }),
      invalidatesTags: ['SpecificAllocation'],
    }),
  }),
});

export const {
  useFindAllSpecificAllocationsGroupedQuery,
  useFindAllSpecificAllocationsByProjectQuery,
  useCreateSpecificAllocationMutation,
  useDeleteSpecificAllocationMutation,
} = SpecificAllocationApi;
